import { getAssignedOrders, deleteOrder, resetPacksTable } from '../services/db';
import { renderLayout } from '../components/layout';
import type { Order } from '../models/order';
//import { saveOrder } from '../services/db';
//import { getDefaultAddress, type Address } from '../models/address';
import { ORDER_STATUS_APPROVED, ORDER_STATUS_CANCELLED, ORDER_STATUS_COMPLETED, ORDER_STATUS_DRAFT, ORDER_STATUS_ORDER, ORDER_STATUS_SURVEYOR_PENDING, ORDER_STATUS_QUOTE, ORDER_STATUS_REJECTED, ORDER_STATUS_SUBMITTED, SALESREP_ROLE, stepTitles, SURVEYOR_ROLE, ORDER_STATUS_PENDING, ORDER_STATUS_REMOVED_FROM_SURVEYOR, ORDER_STATUS_REMOVED_FROM_SALESREP } from '../constants';
import { confirmDangerousAction } from '../components/confirmation-modal';
import { getUserRole } from '../services/auth';
import type { Address } from '../models/address';
import { formatAddressForHTML } from '../utils';
//import { convertLinksToSPA } from '../components/alink';

/**
 * Renders the dashboard content with orders data
 */
function renderDashboardContent(userRole: string | null, orders: Order[]): string {
  if(orders.length === 0) {
    return `<h2 class="ac mt50">No Orders Assigned</h2>`;
  }

  //<button id="new_order_btn" class="new-order-btn" title="new order" >+</button>  
  return `
    <div class="wizard-left wl-large">
      <h3>Orders</h3>
      <table id="orders-table" class="orders-table">
        <thead>
          <tr>
            <th>Order #</th>
            <th>Customer</th>
            <th>Status</th>
            <th>Order Date</th>
            <th>Cost</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          ${
            //${order.step_data.steps.step1.data.customerData.name}
            orders.map((order: Order) => { 

              let customerName = "Unknown Customer";
              if(order.step_data  && order.step_data.steps && order.step_data.steps.step1 && order.step_data.steps.step1.data && order.step_data.steps.step1.data.customerData) {
                customerName = order.step_data.steps.step1.data.customerData.name;
              }

              let stepAction = "";
              if(stepTitles.length > 0 && order.step_data && order.step_data.currentStep < stepTitles.length) {
                stepAction = stepTitles[order.step_data.currentStep];
              }

              let statusClass = "";
              switch(order.status) {
                case ORDER_STATUS_CANCELLED: 
                  statusClass = 'status-cancelled'; 
                  break;
                case ORDER_STATUS_COMPLETED: 
                  statusClass = 'status-completed'; 
                break;
                default: 
                  statusClass = '';
                  break;
              }

              let customerAddress = "";
              if(order.step_data 
                && order.step_data.steps 
                && order.step_data.steps.step1 
                && order.step_data.steps.step1.data 
                && order.step_data.steps.step1.data.customerData 
                && order.step_data.steps.step1.data.customerData.installationAddress) {
                const addr: Address = order.step_data.steps.step1.data.customerData.installationAddress;
                customerAddress = formatAddressForHTML(addr);
              }

              const delMessage = order.status === ORDER_STATUS_CANCELLED ? `(Marked for Deletion)` : "";

              let validToEdit: boolean = false;
              
              if(userRole && userRole === SURVEYOR_ROLE){
                validToEdit = ((order.status === ORDER_STATUS_ORDER) || (order.status === ORDER_STATUS_SURVEYOR_PENDING));
              }
              else if(userRole && userRole === SALESREP_ROLE){
                validToEdit = ((order.status === ORDER_STATUS_QUOTE) || (order.status === ORDER_STATUS_PENDING));
              }
              
              const orderLink = validToEdit === true ? `${customerName}${delMessage}` : customerName;
              return `<tr data-order-id="${order.id}" data-status="${order.status}">
                <td class="ac"><a href="/wizard/${order.id}">#${order.id}</a></td>
                <td>${orderLink} <br/>${customerAddress}</td>
                <td class="${statusClass}">${order.status}</td>
                <td>${new Date(order.orderDate).toLocaleDateString()}</td>
                <td class="ar">£${order.totalContractPrice.toFixed(2)}</td>
                <td>
                  ${order.status === ORDER_STATUS_DRAFT 
                    || (userRole === SURVEYOR_ROLE && order.status === ORDER_STATUS_REMOVED_FROM_SURVEYOR) 
                    || (userRole === SALESREP_ROLE && order.status === ORDER_STATUS_REMOVED_FROM_SALESREP) 
                    || order.status === ORDER_STATUS_CANCELLED 
                    ? `<button class="delete-order-btn" data-order-id="${order.id}">Delete</button>` 
                    : stepAction
                  }
                </td>
              </tr>`;
            }).join('')
          }
        </tbody>
      </table>
    </div>
    <div class="wizard-right wr-small">
      <h3>Filters</h3>
      <div class = "form-group">
        <label for="status-filter">Status:</label>
        <select id="status-filter">
          <option value="">All</option>
          <option value="${ORDER_STATUS_QUOTE}">Quote</option>
          ${ userRole === SALESREP_ROLE ? `<option value="${ORDER_STATUS_PENDING}">Pending</option>` : "" }
          ${ userRole === SALESREP_ROLE ? `<option value="${ORDER_STATUS_SUBMITTED}">Submitted</option>` : "" }

          ${ userRole === SURVEYOR_ROLE ? `<option value="${ORDER_STATUS_SURVEYOR_PENDING}">Pending</option>` : "" }
          ${ userRole === SURVEYOR_ROLE ? `<option value="${ORDER_STATUS_APPROVED}">Approved</option>` : "" }
          ${ userRole === SURVEYOR_ROLE ? `<option value="${ORDER_STATUS_REJECTED}">Rejected</option>` : "" }
          <option value="${ORDER_STATUS_COMPLETED}">Completed</option>
          <option value="${ORDER_STATUS_CANCELLED}">Cancelled</option>
        </select>
      </div>
    </div>
  `;
}

/**
 * Initialize dashboard - called on first page load
 */
export async function initDashboard() {

  const uRole: string | null = getUserRole();
  const orders: Order[] = await getAssignedOrders();
  const content = renderDashboardContent(uRole, orders);
  renderLayout(content);
  
  // Attach event listeners after rendering
  attachDashboardEventListeners();


  if (window.location.search.includes("resetDb=true")) {
    await resetPacksTable();
  }

}

/**
 * Refresh dashboard data - reloads orders from database and updates UI
 * Can be called after sync or other data changes
 */
export async function refreshDashboard() {
  console.log('Refreshing dashboard data...');
  
  // Get current filter state to preserve it
  const statusFilter = document.getElementById('status-filter') as HTMLSelectElement;
  const currentFilterValue = statusFilter?.value || '';
  
  // Reload orders from database
  const uRole: string | null = getUserRole();
  const orders: Order[] = await getAssignedOrders();
  const content: string = renderDashboardContent(uRole, orders);
  
  // Update the app content without re-rendering the entire layout
  const appContent = document.getElementById('app-content');
  if (appContent) {
    appContent.innerHTML = content;
  }
  
  // Reattach event listeners
  attachDashboardEventListeners();
  
  // Restore filter state
  const newStatusFilter = document.getElementById('status-filter') as HTMLSelectElement;
  if (newStatusFilter && currentFilterValue !== 'all') {
    newStatusFilter.value = currentFilterValue;
    // Trigger the filter
    newStatusFilter.dispatchEvent(new Event('change'));
  }
  
  console.log('Dashboard refreshed');
}

/**
 * Attach event listeners for dashboard interactions
 */
function attachDashboardEventListeners() {
  // Status filter
  const statusFilter = document.getElementById('status-filter') as HTMLSelectElement;
  if (statusFilter) {
    statusFilter.addEventListener('change', handleStatusFilter);
  }
  
  // Delete buttons (event delegation)
  const table = document.getElementById('orders-table');
  if (table) {
    table.addEventListener('click', handleDeleteClick);

    //convertLinksToSPA(table);
  }

  // const newOrderBtn = document.getElementById('new_order_btn');
  // if (newOrderBtn) {
  //   newOrderBtn.addEventListener('click', () => {
  //   });
  // }
}

/**
 * Handle status filter changes
 */
function handleStatusFilter(event: Event) {
  const selectedStatus = (event.target as HTMLSelectElement).value;
  const rows = document.querySelectorAll('#orders-table tbody tr');
  
  rows.forEach((row) => {
    const rowStatus = (row as HTMLElement).dataset.status;
    if (selectedStatus === '' || rowStatus === selectedStatus) {
      (row as HTMLElement).style.display = '';
    } else {
      (row as HTMLElement).style.display = 'none';
    }
  });
}

/**
 * Handle delete button clicks with confirmation
 */
async function handleDeleteClick(event: Event) {
  const target = event.target as HTMLElement;
  
  if (target.classList.contains('delete-order-btn')) {
    const orderId = parseInt(target.dataset.orderId || '0', 10);
    
    // Get customer name from the row for a better confirmation message
    const row = target.closest('tr');
    const customerCell = row?.querySelector('td:nth-child(2)');
    let customerName = customerCell?.textContent?.trim() || ""; 
    
    customerName += ` - Order #${orderId}`;
    
    // Use the confirmation modal instead of native confirm
    const confirmed = await confirmDangerousAction(
      'Delete Order From Device?',
      `Are you sure you want to permanently delete<br /> ${customerName}<br /> This action cannot be undone.`,
      'Delete'
    );
    
    if (confirmed) {
      try {
        await deleteOrder(orderId);
        console.log(`[handleDeleteClick] Order ${orderId} deleted successfully`);
        // Reload dashboard to show updated order list
        await refreshDashboard();
      } catch (error) {
        console.error('Failed to delete order:', error);
        alert('Failed to delete order. Please try again.');
      }
    } else {
      console.log(`[handleDeleteClick] Order ${orderId} deletion cancelled`);
    }
  }
}
